import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeDistributionListCreate,
  detail: routeDistributionListDetail,
  home: routeDistributionListsHome,
  root: routeDistributionListsRoot,
} = createDoctypeRoutes({
  createName: 'new-distribution-list',
  createPath: 'new-distribution-list',
  detailName: 'distribution-list-detail',
  doctype: DOCTYPES.EMAIL_GROUP,
  extraListDoctypes: { [DOCTYPES.REPORT]: [PERMISSIONS.READ] },
  homeName: 'distribution-lists',
  path: 'distribution-lists',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/distributionLists/AddDistributionList.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/distributionLists/ViewDistributionList.vue'),
    list: async () => await import('@/components/viewsExternal/newsletter/ViewNewsletter.vue'),
  },
})

export {
  routeDistributionListCreate,
  routeDistributionListDetail,
  routeDistributionListsHome,
  routeDistributionListsRoot,
}
